import { AfterViewInit, Component, OnInit, ViewChild,  SecurityContext } from '@angular/core';
import {  CalendarOptions, FullCalendarComponent,  } from '@fullcalendar/angular'; // useful for typechecking
import { HttpService } from '../../services/http-service/http.service'
import { ModalDirective } from 'ngx-bootstrap/modal';
import { FormGroup, FormBuilder, Validators} from '@angular/forms';
import { AppToastComponent as ToastComp } from '../../services/shared-service/toast-simple/toast.component'
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { LocalInterfaceService } from '../../services/local-inteface-service/local-interface.service';
import { ValidationService } from '../../services/validation-service/validation.service';
import { StorageService } from '../../services/storege-service/storage.service';
import * as moment from 'moment';
import { NgxTippyService } from 'ngx-tippy-wrapper';
import { DomSanitizer } from '@angular/platform-browser';
import { ToolService } from '../../services/tool/tool.service';

@Component({
  selector: 'app-full-calendar-ng',
  templateUrl: './data-tables.component.html',
  styleUrls: ['./data-tables.component.scss',
  "../../../../node_modules/ngx-bootstrap/datepicker/bs-datepicker.css"]
})
export class FullCalendarNgComponent implements OnInit, AfterViewInit {

  // getCalenderDate=()=>{
  //   const lastSelectedDate=this.storageSrv.getLastSelectedDate()
  //   if(!lastSelectedDate)
  //   return new Date(
  //     moment().format('YYYY-MM-DD')
  //   )
  //   return new Date(
  //     moment(lastSelectedDate).format('YYYY-MM-DD')
  //   )
  // }


  public dbData?;
  public dbDataBO?;
  public dbCourtData?;
  public dbCourtDataBO?;
  public courts?;
  public bookingCategories?;
  public coaches?;
  public paymentMethods?;
  public timingSlots?;
  public bookingAddons?;
  public bookingAddonInstances?;
  public disabledData?;
  public isLoading: boolean = true;
  public ownerId;
  public facilityId;
  public bookingId;
  public classId;
  public bookingName;
  public bookingMobile;
  public bookingCountryCode;
  public bookingDate;
  public bookingStartTime;
  public bookingEndTime;
  public bookingPrice;
  public bookingAddon;
  public bookingVAT;
  public bookingTotal;
  public bookingPayAmount;
  public bookingPayStatus?;
  public bookingPayDate;
  public bookingReOccur: boolean = false;
  public bookingReOccurDays;
  public bookingReOccurInstance;
  public bookingTotalWithReoocur;
  public courtPrice;
  public courtPrice30min = 0.0;
  public courtPrice60min = 0.0;
  public courtPrice90min = 0.0;
  public courtPrice120min = 0.0;
  public taxPercentage = 0;
  public ccy;
  public selectedReoccurDay;
  public bookingNotes: string;
  public bookingAddonsArray:Array<{id: number, name: String, count: number, price: number}> = [];
  //public bookingAddonsObject :object = [];
  public existingBookingAddonArray;
  totalRemainingAmount = 0.0
  public totalDiscount = 0.0;
  public calendarCurrentDate = this.storageSrv.getCalenderDate();
  public courtsList = Array();
  public timingList = Array();
  public state = [false, true];
  public bookingReoccurDisabledDate;
  public taxOnus;
  public membershipDescription: string;
  public membershipName: string;
  public memberId?;
  public calendarTimeSlots? = '00:30:00';
  public calendarStartTime? = '00:00:00';
  public calendarEndTime? = '24:00:00';
  calendarDate = this.storageSrv.getCalenderDate();
  bookingCategoryId?: string;
  coachId?: string;

  public responseData?;
  public dbActiveData? = Array();
  public dbFacilityScheduleData? = Array();

  simpleForm: FormGroup;
  isUpdate: boolean = false;
  isError: boolean = false;
  isReoccur: string = '0';
  isAddonBtn: boolean = false;
  court?: string;
  addon?: string;
  paymentMethod?: string;
  endTiming?: string;
  isBookingReoccur: boolean = false;
  facilityCcy=this.storageSrv.getFacilityCcy()

  today = this.storageSrv.getCalenderDate();
  todayStr: string = this.today.toISOString().replace(/T.*$/, '');
  viewTime: '17:00';
  bookingEventPaymentStatus: any = {
    "temporary": "#D3D3D3",
    "partially_paid": "#FF9800",
    "not_paid": "#F44336",
    "paid": "#4CAF50",
  }
  //events = this.dbData;
  public openEvent(info) {
    console.log(info);
  }

  @ViewChild('calendar') calendarComponent!: FullCalendarComponent;
  @ViewChild('openEventModal', {static: false},) public openEventModal: ModalDirective;
  @ViewChild('addBookingModal', {static: false}) public addBookingModal: ModalDirective;
  @ViewChild('reoccurBookingModal', {static: false}) public reoccurBookingModal: ModalDirective;
  @ViewChild(ToastComp) toastComp: ToastComp;


  constructor(
    private httpService: HttpService,
    private fb: FormBuilder,
    private router: Router,
    public route: ActivatedRoute,
    private toastr: ToastrService,
    private localInterfaceSrv: LocalInterfaceService,
    private validationSrv : ValidationService,
    private storageSrv: StorageService,
    private sanitizer: DomSanitizer,
    private tippyService: NgxTippyService,
    public toolService: ToolService,
    ) {
      this.calendarTimeSlots = this.storageSrv.getCalendarTimeSlots() == 'null' ? '00:30:00' : this.storageSrv.getCalendarTimeSlots();
      // this.calendarStartTime = this.storageSrv.getCalendarStartTime();
      // this.calendarEndTime = this.storageSrv.getCalendarEndTime();

      // if (this.calendarEndTime < this.calendarStartTime)
      // {
      //   this.calendarEndTime = '24:00:00';
      // }
      // if (this.calendarEndTime == this.calendarStartTime)
      // {
      //   this.calendarEndTime = '24:00:00';
      // }
      // console.log(moment(this.calendarEndTime).format("HH:mm:ss"));
      // console.log(moment(this.calendarStartTime).format("HH:mm:ss"));

  }


  // onEventMouseEnter(info: any) {
  //   // console.log('info', info);
  //   const event = info.event;

  //   this.tooltipData = {
  //     title: event.title,
  //     start: new Date(event.start).toLocaleString(), // Format start date/time
  //     end: event.end ? new Date(event.end).toLocaleString() : "No end time", // Format end date/time
  //     backgroundColor: event.backgroundColor,
  //     eventType: event.extendedProps.eventType,
  //     status: event.extendedProps.status,
  //     day: event.extendedProps.day
  //   };

  //   this.tooltipPosition = {
  //     top: info.jsEvent.clientY,
  //     left: info.jsEvent.clientX
  //   };

  //   this.tooltipVisible = true;
  // }

  // onEventMouseLeave() {
  //   console.log('Leaving');
  //   // this.tooltipVisible = false;
  //   // this.tooltipData = null;
  // }

  onEventMouseEnter(info: any) {
    const event = info.event;
  // console.log('event',event.id);
    // Set the tooltip data

    this.tooltipData = {
      title: event.title,
      start: this.convertedTime(event.start),
      end: event.end ? this.convertedTime(event.end) : "No end time",
      backgroundColor: event.backgroundColor,
      eventType: event.extendedProps.eventType,
      status: event.extendedProps.status,
      day: event.extendedProps.day,
      total: event.extendedProps.total,
      customerContact: event.extendedProps.customerContact,
      player1A: event.extendedProps.player1A,
      player1B: event.extendedProps.player1B,
      player2A: event.extendedProps.player2A,
      player2B: event.extendedProps.player2B

    };

    // Get viewport dimensions
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;

    // Get mouse position
    const mouseX = info.jsEvent.clientX;
    const mouseY = info.jsEvent.clientY;

    // Set initial tooltip position
    let top = mouseY + 10; // Default below cursor
    let left = mouseX + 10; // Default to the right of cursor

    // Delay applying the tooltip to calculate dimensions after rendering
    setTimeout(() => {
      const tooltipElement = document.querySelector('.custom-tooltip') as HTMLElement;

      if (tooltipElement) {
        const { width: tooltipWidth, height: tooltipHeight } = tooltipElement.getBoundingClientRect();

        // Adjust for bottom edge
        if (mouseY + tooltipHeight + 20 > viewportHeight) {
          top = mouseY - tooltipHeight - 10; // Position above cursor
        }

        // Adjust for right edge
        if (mouseX + tooltipWidth + 20 > viewportWidth) {
          left = mouseX - tooltipWidth - 10; // Position to the left of cursor
        }

        // Adjust for top edge
        if (mouseY - tooltipHeight - 10 < 0) {
          top = mouseY + 10; // Position below cursor
        }

        // Adjust for left edge
        if (mouseX - tooltipWidth - 10 < 0) {
          left = mouseX + 10; // Position to the right of cursor
        }

        // Apply the final calculated position
        this.tooltipPosition = { top, left };
      }
    }, 0);

    this.tooltipVisible = true;
  }
  isTooltipHovered = false;
  onTooltipMouseEnter() {
    console.log('onTooltipMouseEnter');
    // this.isTooltipHovered = true;
  }

  onTooltipMouseLeave() {
    console.log('onTooltipMouseLeave');
    // this.isTooltipHovered = false;
    // this.tooltipVisible = false;
  }
  convertedTime=(dateString:string) =>{
    const options = {
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,
  };
  // @ts-ignore: Ignore type checking for the next line
    return new Date(dateString).toLocaleString('en-US', options)
  }

  onEventMouseLeave() {
    this.tooltipVisible = false;
    this.tooltipData = null;
  }
  tooltipVisible = false;
  tooltipData: any = null;
  tooltipPosition = { top: 0, left: 0 };

  calendarOptions: CalendarOptions = {
    eventMouseEnter: this.onEventMouseEnter.bind(this),
    eventMouseLeave: this.onEventMouseLeave.bind(this),
    initialDate: this.calendarCurrentDate,
    weekNumberCalculation: 'ISO',
    height: 'auto',
    //contentHeight: 1000,
    //eventMinHeight: 50,
    //eventShortHeight: 50,
    // dayMinWidth: 250,
    // aspectRatio: 5,
    initialView: 'resourceTimeGridDay',
    headerToolbar: {
      left: 'prev,next',
      center: 'title',
      right: '',
    },
    views: {
      dayGrid: {
        // options apply to dayGridMonth, dayGridWeek, and dayGridDay views
      },
      day: {
        // options apply to dayGridDay and timeGridDay views
      },
      resourceTimeGridDay: {
        type: 'resourceTimeGrid',
        duration: { days: 1 },
        buttonText: '1 day',
        titleFormat: { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' },
        eventMinHeight: 10,
        eventShortHeight: 100
        //height: 100
        //contentHeight: 200,
        //height:'150%'
      },
    },
    editable: true,
    selectable: true,
    navLinks: true,
    // datech: (event) => {
    //   console.log("1")
    // },
    //slotLabelInterval: '01:00:00',
    slotDuration: this.calendarTimeSlots.toString() == 'null' ? '00:30:00' : this.calendarTimeSlots,
    // slotMinTime: this.calendarStartTime,
    // slotMaxTime: this.calendarEndTime,
    nowIndicator: true,
    allDaySlot: false,
    datesAboveResources:true,
    //expandRows: true,
    //eventMinHeight: 500,
    eventOrder:'resourceId',
    datesSet: async () => {
      this.getCurrentDateData();
    },
    viewDidMount: () => {
      var calDate = document.getElementById('calendarDate') as HTMLInputElement;
      calDate.valueAsDate = new Date(
      moment(this.calendarDate).format('YYYY-MM-DD')
      );
    const lastSelectedDate=this.storageSrv.getLastSelectedDate()
    if(lastSelectedDate)
      this.storageSrv.removeLastSelectedDate()

    },
    eventClick: async (selectedBooking) =>
    {
    try {
      const res=await this.localInterfaceSrv
        .getBookingDetails(selectedBooking.event.id)
      if (selectedBooking.event.extendedProps?.eventType == 'booking')
       {
         this.manageBooking(selectedBooking,res?.data?.content)

       }
       else if (selectedBooking.event.extendedProps?.eventType == 'reoccur')
       {
        this.manageReoccurBooking(selectedBooking,res?.data?.content);

        //this.toastr.info('This booking can only be modified from the bookings menu', "Reccurrant Booking");
       }
       else
       {
         ''
       }

    } catch (error) {
      console.log('error',error);
      this.toastr.error(error.description, "Error");

    }

    },
    select: (selectedBooking) => {this.addBooking(selectedBooking)},
    schedulerLicenseKey: 'CC-Attribution-NonCommercial-NoDerivatives'
  };
  async getCurrentDateData() {
    var calDate = document.getElementById('calendarDate') as HTMLInputElement;

    let calendarApi = this.calendarComponent?.getApi();
    if (
      calendarApi?.getDate() != calDate.valueAsDate &&
      calendarApi?.getDate() != undefined
    ) {
      const updatedDate = moment(calendarApi?.getDate()).toDate();

      calDate.valueAsDate = new Date(
        moment(updatedDate).format('YYYY-MM-DD')
      );

      const dateTime1 = moment(calDate.valueAsDate).format('YYYY-MM-DD');
      await this.loadEventsAccordingToDate(dateTime1, this.facilityId);
      await this.ngAfterViewInit();

      this.calendarOptions.initialDate = calDate.valueAsDate;
      this.calendarDate = updatedDate;
      this.isLoading = false;
    }
  }

  createForm() {

      this.simpleForm = this.fb.group({
      //calendarDate: [this.calendarCurrentDate],
      calendarDate: {value: this.calendarDate},
      bookingId: {value: this.bookingId, disabled:true},
      court: [this.court, [Validators.required]],
      paymentMethod: [this.paymentMethod],
      endTiming: [this.endTiming],
      addon: [this.addon],
      bookingAddonInstances: {value: this.bookingAddonInstances, disabled:true},
      bookingName: [this.bookingName, [Validators.required]],
      bookingMobile: [this.bookingMobile, [Validators.required]],
      bookingCountryCode: [this.bookingCountryCode, [Validators.required]],
      bookingCategoryId: [this.bookingCategoryId],
      coachId: [this.coachId],
      bookingNotes: [this.bookingNotes],
      bookingDate: [this.bookingDate, [Validators.required]],
      bookingStartTime: [this.bookingStartTime, [Validators.required]],
      //bookingEndTime: [this.bookingEndTime, [Validators.required]],
      bookingPrice: {value: this.bookingPrice, disabled:false},
      bookingAddon: {value: this.bookingAddon, disabled:true},
      bookingVAT: {value: this.bookingVAT, disabled:true},
      bookingTotal: {value: this.bookingTotal, disabled:true},
      totalDiscount: {value: this.totalDiscount},
      totalRemainingAmount: {value: this.totalRemainingAmount, disabled:true},
      bookingPayAmount: {value: this.bookingPayAmount, disabled:true},
      bookingPayStatus: {value: this.bookingPayStatus, disabled:true},
      bookingPayDate: {value: this.bookingPayDate, disabled:true},
      bookingReOccur: {value: this.bookingReOccur},
      bookingReOccurDays: {value: this.bookingReOccurDays, disabled:true},
      bookingReOccurInstance: {value: this.bookingReOccurInstance, disabled:true},
      bookingTotalWithReoocur: {value: this.bookingTotalWithReoocur, disabled:true},
    }, { });
  }

  ngOnInit(): void {
    this.simpleForm = this.fb.group({});
    this.validationSrv.validateAcess()
    .then(async () => {
      this.route.queryParams.subscribe(async params => {
        this.facilityId = this.storageSrv.getFacilityId();
        // if(this.facilityId=='138') {
        //   require("../../../scss/style1.scss");
        // }
        this.ownerId = this.storageSrv.getUser();
        await this.loadCourts(this.facilityId);
        await this.loadAddons(this.facilityId);
        await this.loadCourtsCalendar(this.facilityId);
        // await this.loadBookingsCalendar(this.facilityId);
        await this.loadEventsAccordingToDate(
          moment(this.calendarCurrentDate).format('YYYY-MM-DD'),
          this.facilityId
        );
        await this.loadBookingCategory(this.facilityId);
        await this.loadCoaches();
        //await this.loadDisabledCalendar(this.facilityId);
        await this.loadPaymentMethods(this.facilityId);
        await this.loadTimingSlots(this.facilityId);
        await this.createForm();
        await this.ngAfterViewInit();
        this.isLoading = false;
        this.calendarOptions.initialDate = this.calendarCurrentDate;
        this.calendarOptions.slotDuration = this.calendarTimeSlots.toString() == 'null' ? '00:30:00' : this.calendarTimeSlots;
        // this.calendarOptions.slotMinTime = this.calendarStartTime.toString() == 'null' ? '00:00:00' : this.calendarStartTime;
        // this.calendarOptions.slotMaxTime = this.calendarEndTime.toString() == 'null' ? '24:00:00' : this.calendarEndTime

        await this.updateCalendar();
    });
    });
  }

  toggleChange(event)
  {
    this.isLoading = true;
    const calendarApi = this.calendarComponent?.getApi();

    if (event.checked)
    {
       calendarApi.getEvents().forEach(event => {
        if (event.extendedProps?.channel == "online")
        {
          event.setProp("backgroundColor", '#daf1fe');
        }
        else if (event.extendedProps?.channel == "backoffice")
        {
          event.setProp("backgroundColor", '#eaeee0');
        }
        else
        {
          //console.log(event.extendedProps?.channel + "8888888");
        }
      })
    }
    else
    {
      calendarApi.getEvents().forEach(event => {
        event.setProp("backgroundColor", '');
      });
    }
    this.isLoading = false;
  }

  checkViewDate() {
    let calendarApi = this.calendarComponent?.getApi();
    this.calendarCurrentDate = calendarApi?.getDate();
    //calendarApi?.gotoDate(this.calendarCurrentDate);
  }
  setViewDate() {
    var calendarDate = document.getElementById('calendarDate') as HTMLInputElement;

    if (calendarDate.value != null){
      let calendarApi = this.calendarComponent?.getApi();
      //this.calendarCurrentDate = calendarApi?.getDate();
      calendarDate.value = calendarApi?.getDate().toISOString();
      //calendarApi?.gotoDate(this.calendarCurrentDate);
    }
  }

  public goToDate(event) {
    var calendarDate = document.getElementById('calendarDate') as HTMLInputElement;
    console.log(calendarDate.value);
    //console.log(this.f['calendarDate']?.value.value);
    var calendarSelectedDate = moment(new Date(this.simpleForm.controls['calendarDate'] ? this.f['calendarDate'].value : null)).format("YYYY-MM-DD");
    //var calendarSelectedDate = this.f['calendarDate']?.value;
    //console.log(calendarSelectedDate);
    let calendarApi = this.calendarComponent?.getApi();
    calendarApi?.gotoDate(calendarDate.value);
  }


  ngAfterViewInit() {
    setTimeout(() => {
      const calendarApi = this.calendarComponent?.getApi();
      //calendarApi?.setOption("slotMinTime",'00:30:00');
      //calendarApi?.setOption("slotMaxTime",'24:30:00');
      //this.calendarOptions.slotMaxTime = '24:30:00';
      calendarApi?.updateSize();
      calendarApi?.setOption("slotDuration", this.calendarTimeSlots);
      if (this.facilityId==138 || this.facilityId ==139 || this.facilityId ==140 || this.facilityId ==141 || this.facilityId ==142
        || this.facilityId ==143 || this.facilityId ==146 || this.facilityId ==147|| this.facilityId ==148 || this.facilityId ==150) {
        document.querySelectorAll('.fc-timegrid-slot').forEach(slot => {
          if (slot instanceof HTMLElement) {
            slot.style.height = "5em";
          }
        });
        calendarApi?.setOption('contentHeight',200)
      }
    }, 100);
  }

  loadCourts = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      this.dbActiveData = Array();
      this.localInterfaceSrv.getCourts(facilityId)
      .then(res => {
        this.responseData = Object.values(res);
        this.responseData[0].forEach(item => {
          if (item.status=='A')
          {
            const newObj = item;
            this.dbActiveData.push(newObj);
          }
        });
        this.courts = this.dbActiveData;
        this.courts.offers = res.offers;
        resolve(res);
      })
      .catch(err => {
        reject(err);
        console.log(err)
        this.toastr.error(err.description, "Error");
      })
      .finally();
    });
  }

  loadAddons = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      this.localInterfaceSrv.getAddonsTable(facilityId)
      .then(res => {
        this.bookingAddons = res;
        resolve(res);
      })
      .catch(err => {
        reject(err);
        this.toastr.error(err.description, "Error");
      })
      .finally();
    });
  }

  loadBookingsCalendar = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      this.localInterfaceSrv.getBookingsCalendar(facilityId)
      .then(res => {
        this.dbData = res;
        var dbFiltered = this.dbData.filter((booking => booking.eventType != 'disabled'))
        this.dbData.forEach(booking => {
          if (booking.eventType == 'disabled')
          {
              booking.resourceIds = booking.resourceIds?.split(',');
              var startDate = moment(booking.start).subtract(1, "days");
              var endDate = moment(booking.end);
              var startDT = moment(booking.start);
              var endTime = endDate.format("HH:mm:ss");

              while (startDate.isBefore(endDate, 'days'))
              {
                startDate = startDate.add(1, 'days');
                var endDT = moment(startDate.format("YYYY-MM-DD") + ' ' + endTime, 'YYYY-MM-DD HH:mm:ss');
                booking.start = startDate.toDate();
                booking.end = endDT.toDate();
                const newObj = {...booking};
                dbFiltered.push(newObj);
              }
          }
        });
        this.calendarOptions.events = dbFiltered;
        resolve(res);
      })
      .catch(err => {
        reject(err);
        console.log(err)
        this.toastr.error(err.description, "Error");
      })
      .finally();
    });
  }

  loadEventsAccordingToDate = async (dateValue, facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      this.localInterfaceSrv
        .getSingleDayBookings(facilityId, dateValue)
        .then((res) => {
          this.dbData = res.data.content;

          var dbFiltered = this.dbData.filter(
            (booking) => booking.eventType != 'disabled'
          );
          this.dbData.forEach((booking) => {
            if (booking.eventType == 'disabled') {
              booking.resourceIds = booking.resourceIds?.split(',');
              var startDate = moment(booking.start).subtract(1, 'days');
              var endDate = moment(booking.end);
              var startDT = moment(booking.start);
              var endTime = endDate.format('HH:mm:ss');

              while (startDate.isBefore(endDate, 'days')) {
                startDate = startDate.add(1, 'days');
                var endDT = moment(
                  startDate.format('YYYY-MM-DD') + ' ' + endTime,
                  'YYYY-MM-DD HH:mm:ss'
                );
                booking.start = startDate.toDate();
                booking.end = endDT.toDate();
                const newObj = { ...booking };
                dbFiltered.push(newObj);
              }
            }
          });
          this.calendarOptions.events = dbFiltered;

          resolve(res.data.content);
        })
        .catch((err) => {
          reject(err);
          console.log(err);
          this.toastr.error(err.description, 'Error');
        })
        .finally();
    });
  };

  loadCourtsCalendar = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      this.courtsList = Array();
      this.localInterfaceSrv.getCourtsCalendar(facilityId)
      .then(res => {
        this.dbCourtData = res;
        this.dbCourtData.forEach(element => {
          this.courtsList.push(element.id);
        });
        this.calendarOptions.resources = this.dbCourtData;
        resolve(res);
      })
      .catch(err => {
        reject(err);
        console.log(err)
        this.toastr.error(err.description, "Error");
      })
      .finally();
    });
  }

  loadDisabledCalendar = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      this.localInterfaceSrv.getDisabledCalendar(facilityId)
      .then(res => {
        this.disabledData = res;
        this.updateCalendar();
        resolve(res);
      })
      .catch(err => {
        reject(err);
        console.log(err)
        this.toastr.error(err.desc, "Error");
      })
      .finally();
    });
  }

  loadPaymentMethods = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      this.localInterfaceSrv.getPaymentMethods(facilityId)
      .then(res => {
        this.paymentMethods = res;
        resolve(res);
      })
      .catch(err => {
        reject(err);
        console.log(err)
        this.toastr.error(err.description, "Error");
      })
      .finally();
    });
  }

  loadTimingSlots = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      this.localInterfaceSrv.getTimingSlots(facilityId)
      .then(res => {
        this.timingSlots = res.content;
        if (this.timingSlots == ''){
          var defaultSlots:Array<{nameEn: string, timingInMinutes: number}> = [];
          defaultSlots.push({
            nameEn: '30 Minutes',
            timingInMinutes: 30
          });
          defaultSlots.push({
            nameEn: '1 Hour',
            timingInMinutes: 60
          });
          defaultSlots.push({
            nameEn: '1 Hour 30 Minutes',
            timingInMinutes: 90
          });
          defaultSlots.push({
            nameEn: '2 Hours',
            timingInMinutes: 120
          });
          defaultSlots.push({
            nameEn: '2 Hours 30 Minutes',
            timingInMinutes: 150
          });
          defaultSlots.push({
            nameEn: '3 Hours',
            timingInMinutes: 180
          });
          defaultSlots.push({
            nameEn: '3 Hours 30 Minutes',
            timingInMinutes: 210
          });
          defaultSlots.push({
            nameEn: '4 Hours',
            timingInMinutes: 240
          });
          defaultSlots.push({
            nameEn: '4 Hours 30 Minutes',
            timingInMinutes: 270
          });
          defaultSlots.push({
            nameEn: '5 Hours',
            timingInMinutes: 300
          });
          defaultSlots.push({
            nameEn: '5 Hours 30 Minutes',
            timingInMinutes: 330
          });
          defaultSlots.push({
            nameEn: '6 Hours',
            timingInMinutes: 360
          });
          this.timingSlots = defaultSlots;
        }
        resolve(res);
      })
      .catch(err => {
        reject(err);
        console.log(err)
        this.toastr.error(err.description, "Error");
      })
      .finally(
      );
    });
  }


  cancelRecurrantBooking = (staffId,bookingId,bookingDisabledDate) => {
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      this.localInterfaceSrv.cancelRecurrantBooking(staffId,bookingId,bookingDisabledDate)
      .then(res => {
        this.toastr.success('Reoccur Booking Removed', 'Success');
        this.reoccurBookingModal.hide();
        this.ngOnInit();
        resolve(res);
      })
      .catch(err => {
        reject(err);
        console.log(err)
        this.toastr.warning(err.desc, "Warning");
        this.reoccurBookingModal.hide();
      })
      .finally(()=>this.isLoading = false);
    });
  }

  public addBooking(selectedBooking)
  {
    // reset the form for add booking case
    this.simpleForm.reset();

    this.f['bookingName'].enable();
    this.f['bookingMobile'].enable();
    this.f['bookingCountryCode'].enable();

    this.checkViewDate();
    this.isUpdate = false;
    this.bookingReOccur = false;
    this.bookingReOccurInstance = 1;
    var startDate = new Date(selectedBooking.start);
    var endDate = new Date(selectedBooking.end);
    const minutes = (endDate.getTime() - startDate.getTime())/60000;

    var selectedCourtId = selectedBooking.resource.id;
    var taxPercent = selectedBooking.resource.extendedProps.taxPercentage/100;
    this.taxOnus = selectedBooking.resource.extendedProps.taxOnus;
    var ccy = selectedBooking.resource.extendedProps.ccy;
    this.taxPercentage = taxPercent;
    this.ccy = ccy;
    var duration = (minutes);
    var vat = 0.0;
    var total;
    var subTotalPrice;
    var addon = 0.0;
    var addonTotalPrice = 0.0;

    //Ge max allowed timing slot from database
    var maxTimingSlot = Math.max.apply(Math, this.timingSlots.map(function(o) { return o.timingInMinutes; }));

    if (duration > maxTimingSlot)
    {
      this.toastr.warning("Selected duration exceeding max allowed slot by facility [" + maxTimingSlot + " minutes]", "Warning");
      return;
    }

    var isOffer = false;
    for (let offer of this.courts.offers)
    {
      var offerStartDate = new Date(offer.startDT.replace(/-/g, "/"));
      var offerEndDate = new Date(offer.endDT.replace(/-/g, "/"));

      var offerStartDateM = moment(offer.startDT);
      var offerEndDateM = moment(offer.endDT);
      var startDateM = moment(startDate);
      var endDateM = moment(endDate);

      // console.log("offerStartDateM" + offerStartDateM);
      // console.log("offerEndDateM" + offerEndDateM);
      // console.log("startDateM" + startDateM);
      // console.log("endDateM" + endDateM);

      var courtIds = offer.courtIds?.split(',');
      var reoccurDays = offer.reoccurDays?.split(',');

      if (startDateM >= offerStartDateM && startDateM <= offerEndDateM && courtIds.indexOf(selectedCourtId) > -1)
      {

        var bookingStartDate = moment(startDate).format("YYYY-MM-DD");
        var offerStartTime = moment(bookingStartDate + ' ' + offer["startTimeOnly"]).format("YYYY-MM-DD HH:mm:ss");

        var bookingStartTime = moment(startDate).format("YYYY-MM-DD HH:mm:ss");
        var bookingEndTime = moment(endDate).format("YYYY-MM-DD HH:mm:ss");

        var bookingEndDate = moment(endDate).format("YYYY-MM-DD");

        if (offer["endTimeOnly"] > offer["startTimeOnly"])
        {
          bookingEndDate = bookingStartDate;
        }
        var offerEndTime = moment(bookingEndDate + ' ' + offer["endTimeOnly"]).format("YYYY-MM-DD HH:mm:ss");

        // console.log("offerStartTime" + offerStartTime);
        // console.log("offerEndTime" + offerEndTime);
        // console.log("bookingStartTime" + bookingStartTime);

        this.updateReoccurDay();

        if (bookingStartTime >= offerStartTime && bookingStartTime < offerEndTime && courtIds.indexOf(selectedCourtId) > -1 && reoccurDays.indexOf(this.selectedReoccurDay.toLowerCase()) > -1)
        {
          console.log("isOffer");
          isOffer = true;
          this.courtPrice30min = parseFloat(offer["30minPrice"]);
          this.courtPrice60min = parseFloat(offer["60minPrice"]);
          this.courtPrice90min = parseFloat(offer["90minPrice"]);
          this.courtPrice120min = parseFloat(offer["120minPrice"]);
          break;
        }
        else
        {
          for (let court of this.courts)
          {
            if (court.id == selectedCourtId)
            {
              this.courtPrice30min = parseFloat(court["30minPrice"]);
              this.courtPrice60min = parseFloat(court["60minPrice"]);
              this.courtPrice90min = parseFloat(court["90minPrice"]);
              this.courtPrice120min = parseFloat(court["120minPrice"]);
            }
          }
        }
      }
      else
      {
        for (let court of this.courts)
        {
          if (court.id == selectedCourtId)
          {
            this.courtPrice30min = parseFloat(court["30minPrice"]);
            this.courtPrice60min = parseFloat(court["60minPrice"]);
            this.courtPrice90min = parseFloat(court["90minPrice"]);
            this.courtPrice120min = parseFloat(court["120minPrice"]);
          }
        }
      }
    }

    if (!isOffer)
    {
      for (let court of this.courts)
      {
        if (court.id == selectedCourtId)
        {
          this.courtPrice30min = parseFloat(court["30minPrice"]);
          this.courtPrice60min = parseFloat(court["60minPrice"]);
          this.courtPrice90min = parseFloat(court["90minPrice"]);
          this.courtPrice120min = parseFloat(court["120minPrice"]);
        }
      }
    }

    if (duration == 30)
    {
      this.courtPrice = this.courtPrice30min;
    }
    else if (duration == 60)
    {
      this.courtPrice = this.courtPrice60min;
    }
    else if (duration == 90)
    {
      this.courtPrice = this.courtPrice90min;
    }
    else if (duration == 120)
    {
      this.courtPrice = this.courtPrice120min;
    }
    else if (duration > 120)
    {
      var totalExtraTime = duration - 120;
      var totalExtraSlots = totalExtraTime / 30;
      var totalExtraPrice = totalExtraSlots * this.courtPrice30min;
      this.courtPrice = this.courtPrice120min + totalExtraPrice;
    }
    else
    {
      this.courtPrice = this.courtPrice120min;
    }

    subTotalPrice = this.courtPrice;

    for (let addonItem of this.bookingAddonsArray)
    {
      var addonItemPrice = addonItem.price * addonItem.count;
      addonTotalPrice = addonTotalPrice + addonItemPrice;
    }

    var totalPriceWithAddon = (subTotalPrice + addonTotalPrice);
    vat = totalPriceWithAddon * taxPercent;
    var totalPriceWithVAT = totalPriceWithAddon + (this.taxOnus == '1' ? 0 : vat);
    total = totalPriceWithVAT;

    this.simpleForm.patchValue({court: selectedCourtId},{emitEvent: false});
    this.simpleForm.patchValue({bookingCountryCode: this.storageSrv.getFacilityCountryCode()},{emitEvent: false});
    this.simpleForm.patchValue({bookingDate: selectedBooking.start},{emitEvent: false});
    this.simpleForm.patchValue({bookingStartTime: selectedBooking.start},{emitEvent: false});
    this.simpleForm.patchValue({endTiming: duration},{emitEvent: false});
    this.simpleForm.patchValue({bookingPrice: subTotalPrice, disabled:false},{emitEvent: false});
    this.simpleForm.patchValue({bookingAddon: addon},{emitEvent: false});
    this.simpleForm.patchValue({bookingVAT: this.roundTo(vat, 3), disabled:true},{emitEvent: false});
    this.simpleForm.patchValue({bookingTotal: this.roundTo(total, 3), disabled:true},{emitEvent: false});
    this.simpleForm.patchValue({bookingReOccur: this.bookingReOccur},{emitEvent: false});
    this.simpleForm.patchValue({bookingReOccurInstance: this.bookingReOccurInstance},{emitEvent: false});
    this.simpleForm.patchValue({bookingTotalWithReoocur: total},{emitEvent: false});
    this.addBookingModal.show();
  }

  public manageBooking(info,bookingDetails)
  {
    this.checkViewDate();
    this.isUpdate = true;
    if (bookingDetails?.eventType == 'reoccur')
    {

      this.isBookingReoccur = true;
    }
    else
    {

      this.isBookingReoccur = false;
    }


    // if (bookingDetails?.channel == 'online')
    // {
    //   this.f['bookingName'].disable();
    //   this.f['bookingMobile'].disable();
    //   this.f['bookingCountryCode'].disable();
    // }
    // else
    // {
    //   this.f['bookingName'].enable();
    //   this.f['bookingMobile'].enable();
    //   this.f['bookingCountryCode'].enable();

    // }


    var resources = info.event.getResources();
    console.log('resources',resources);
    var resourceId = resources.map(function(resource) { return resource.id });

    //var duration = info.event.extendedProps.duration;
    this.taxPercentage = bookingDetails?.taxPercentage/100;
    var startDate = new Date(info.event.start);
    var endDate = new Date(info.event.end);
    const duration = (endDate.getTime() - startDate.getTime())/60000;

    this.bookingAddonsArray = [];
    if (bookingDetails.addons != undefined){

    for (let item of bookingDetails.addons)
    {
      this.bookingAddonsArray.push(item);
    }
  }
    this.existingBookingAddonArray = [...this.bookingAddonsArray];

    var isOffer = false;

    for (let offer of this.courts.offers)
    {
      isOffer = true;
      var offerStartDate = new Date(offer.startDT.replace(/-/g, "/"));
      var offerEndDate = new Date(offer.endDT.replace(/-/g, "/"));

      if (startDate >= offerStartDate && startDate <= offerEndDate)
      {
        var bookingStartDate = moment(startDate).format("YYYY-MM-DD");
        var offerStartTime = moment(bookingStartDate + ' ' + offer["startTimeOnly"]).format("YYYY-MM-DD HH:mm:ss");

        var bookingStartTime = moment(startDate).format("YYYY-MM-DD HH:mm:ss");
        var bookingEndTime = moment(endDate);

        var bookingEndDate = moment(endDate).format("YYYY-MM-DD");

        if (offer["endTimeOnly"] > offer["startTimeOnly"])
        {
          bookingEndDate = bookingStartDate;
        }

        var offerEndTime = moment(bookingEndDate + ' ' + offer["endTimeOnly"]).format("YYYY-MM-DD HH:mm:ss");

        var courtIds = offer.courtIds?.split(',');
        var reoccurDays = offer.reoccurDays?.split(',');

        this.selectedReoccurDay = moment(startDate).format("dddd");

        if (bookingStartTime >= offerStartTime && bookingStartTime < offerEndTime && courtIds.indexOf(resourceId.toString()) > -1 && reoccurDays.indexOf(this.selectedReoccurDay.toLowerCase()) > -1)
        {
          this.courtPrice30min = parseFloat(offer["30minPrice"]);
          this.courtPrice60min = parseFloat(offer["60minPrice"]);
          this.courtPrice90min = parseFloat(offer["90minPrice"]);
          this.courtPrice120min = parseFloat(offer["120minPrice"]);
          break;
        }
        else
        {
          for (let court of this.courts)
          {
            if (court.id == resourceId)
            {
              this.courtPrice30min = parseFloat(court["30minPrice"]);
              this.courtPrice60min = parseFloat(court["60minPrice"]);
              this.courtPrice90min = parseFloat(court["90minPrice"]);
              this.courtPrice120min = parseFloat(court["120minPrice"]);
            }
          }
        }
      }
      else
      {
        for (let court of this.courts)
        {
          if (court.id == resourceId)
          {
            this.courtPrice30min = parseFloat(court["30minPrice"]);
            this.courtPrice60min = parseFloat(court["60minPrice"]);
            this.courtPrice90min = parseFloat(court["90minPrice"]);
            this.courtPrice120min = parseFloat(court["120minPrice"]);
          }
        }
      }
    }

    if (!isOffer)
    {
      for (let court of this.courts)
      {
        if (court.id == resourceId)
        {
          this.courtPrice30min = parseFloat(court["30minPrice"]);
          this.courtPrice60min = parseFloat(court["60minPrice"]);
          this.courtPrice90min = parseFloat(court["90minPrice"]);
          this.courtPrice120min = parseFloat(court["120minPrice"]);
        }
      }
    }

    var payStatus = bookingDetails?.paymentStatus;
    var paidDate = bookingDetails?.paidDate != null ? new Date(bookingDetails?.paidDate.replace(/-/g, "/")) : '';
    // if (bookingDetails.paymentStatus == 1)
    // {
    //   payStatus = 'Paid';
    //   paidDate = new Date(bookingDetails.paidDate);
    // }
    // else
    // {
    //   payStatus = 'Not Paid';
    // }
    var addon;
    if (bookingDetails?.addon == null)
    {
      addon = 0;
    }
    else
    {
      addon = bookingDetails?.addon;
    }
    this.bookingId = info.event.id;
    this.classId = bookingDetails?.classId;
    this.totalRemainingAmount = this.roundTo(parseFloat(bookingDetails?.totalPrice == null ? '0' : bookingDetails?.totalPrice) - parseFloat(bookingDetails?.paidAmount == null ? '0' : bookingDetails.paidAmount), 3);
    this.simpleForm.patchValue({bookingId: this.bookingId});
    this.simpleForm.patchValue({court: resourceId});
    this.simpleForm.patchValue({bookingCategoryId: bookingDetails?.bookingCategoryId});
    this.simpleForm.patchValue({coachId: bookingDetails?.coachId});
    this.simpleForm.patchValue({bookingName: bookingDetails?.customerName});
    this.simpleForm.patchValue({bookingMobile: bookingDetails?.customerMobile});
    this.simpleForm.patchValue({bookingCountryCode: bookingDetails?.customerCountryCode});
    this.simpleForm.patchValue({bookingNotes: bookingDetails?.notes});
    this.simpleForm.patchValue({bookingDate: info.event.start});
    this.simpleForm.patchValue({bookingStartTime: info.event.start});
    //this.simpleForm.patchValue({bookingEndTime: info.event.end});
    this.simpleForm.patchValue({endTiming: duration});
    this.simpleForm.patchValue({bookingPrice: this.roundTo(bookingDetails?.subTotalPrice, 3)});
    this.simpleForm.patchValue({bookingAddon: addon});
    this.simpleForm.patchValue({bookingVAT: this.roundTo(bookingDetails?.tax, 3)});
    this.simpleForm.patchValue({bookingTotal: bookingDetails?.totalPrice == null ? '0' : this.roundTo(bookingDetails?.totalPrice, 3)});
    this.simpleForm.patchValue({bookingPayAmount: bookingDetails?.paidAmount == null ? '0' : bookingDetails?.paidAmount});
    this.simpleForm.patchValue({bookingPayStatus: payStatus});
    this.simpleForm.patchValue({bookingPayDate: paidDate});
    this.simpleForm.patchValue({totalRemainingAmount: this.totalRemainingAmount});
    this.simpleForm.patchValue({totalDiscount: bookingDetails?.totalDiscount});
    this.simpleForm.get('paymentMethod').clearValidators();
    this.simpleForm.get('paymentMethod').updateValueAndValidity();
    this.simpleForm.get('endTiming').clearValidators();
    this.simpleForm.get('endTiming').updateValueAndValidity();

    this.openEventModal.show();
    this.openEventModal.dismissReason = 'backdrop-click';

  }
  public manageReoccurBooking(info,bookingDetails)
  {
    this.checkViewDate();
    this.isUpdate = true;
    // var resources = info.event.getResources();
    // var resourceId = resources.map(function(resource) { return resource.id });
    this.bookingId = info.event.id;
    this.classId = bookingDetails?.classId;
    this.bookingReoccurDisabledDate = moment(new Date(info.event.start)).format("YYYY-MM-DD HH:mm:ss");
    this.reoccurBookingModal.show();
    this.openEventModal.dismissReason = 'backdrop-click';

  }
  public updateBooking(content: object)
  {
    this.isLoading = true;
    var fd = new FormData();
    // stop here if form is invalid
    if (this.simpleForm.invalid) {
      var msg = "";
      if (this.simpleForm.controls['bookingName'].invalid)
      {
        msg = "booking Name is not valid."
      }
      else if (this.simpleForm.controls['bookingMobile'].invalid)
      {
        msg = "booking mobile is not valid."
      }
      else if (this.simpleForm.controls['bookingDate'].invalid)
      {
        msg = "bookingDate not valid"
      }
      else if (this.simpleForm.controls['bookingStartTime'].invalid)
      {
        msg = "Invalid bookingStartTime"
      }
      // else if (this.simpleForm.controls['bookingEndTime'].invalid)
      // {
      //   msg = "Invalid bookingEndTime"
      // }
      else
      {
        msg = 'An error has occured, please check missing fields and try again';
      }
      this.toastr.warning(msg, "Error");
      this.toastr.warning("Check Invalid Fields: " + this.findInvalidControls(), "Error");
      //this.showError("Check Invalid Fields: " + this.findInvalidControls());
      return;
    }
    console.log("this.f['court'].value" + this.f['court'].value);
    if (this.f['court'].value == 'null' || this.f['court'].value == 0 || this.f['court'].value == null)
    {
      msg = "Please select a court";
      this.toastr.warning(msg, "Error");
      return;
    }

    if (this.f['endTiming'].value == 'null' || this.f['endTiming'].value == 0 || this.f['endTiming'].value == null)
    {
      msg = "Please select a timing slot";
      this.toastr.warning(msg, "Error");
      return;
    }

    var bookingAddons;
    var newAddons;
    // if (this.bookingAddonsArray.length > 0)
    // {
    //   if (this.existingBookingAddonArray != null)
    //   {
    //     if (this.existingBookingAddonArray.length > 0)
    //     {
    //       newAddons = this.bookingAddonsArray.filter(item => this.existingBookingAddonArray.indexOf(item) < 0);
    //       bookingAddons = newAddons;
    //       //this.bookingAddon = this.bookingAddonsArray;
    //     }
    //     else
    //     {
    //       bookingAddons = this.bookingAddonsArray;
    //     }
    //   }
    //   else
    //   {
    //     bookingAddons = this.bookingAddonsArray;
    //   }
    // }
    bookingAddons = this.bookingAddonsArray;

    console.log('this.bookingAddonsArray.length' + this.bookingAddonsArray.length);
    //console.log('this.existingBookingAddonArray.length' + this.existingBookingAddonArray.length);
    console.log('newAddons' + newAddons);
    console.log('bookingAddons' + bookingAddons);


    bookingAddons = JSON.stringify(bookingAddons)

    //this.existingBookingAddonArray = this.bookingAddonsArray;

    // TODO: Use EventEmitter with form value
    this.court = this.f['court'].value
    this.bookingCategoryId = this.f['bookingCategoryId'].value
    this.coachId = this.f['coachId'].value
    this.paymentMethod = this.f['paymentMethod'].value
    this.bookingName = this.f['bookingName'].value
    this.bookingMobile = this.f['bookingMobile'].value
    this.bookingCountryCode = this.f['bookingCountryCode'].value
    this.bookingNotes = this.f['bookingNotes'].value
    this.bookingDate = this.f['bookingDate'].value
    this.bookingStartTime = this.f['bookingStartTime'].value
    this.endTiming = this.f['endTiming'].value
    //this.bookingEndTime = this.f['bookingEndTime'].value
    if (this.isUpdate)
    {
      //BEFORE CHANGE
      // this.bookingPrice = this.f['newBookingPrice'].value
      // this.bookingAddon = this.f['newBookingAddon'].value
      // this.bookingVAT = this.f['newBookingVAT'].value
      // this.bookingTotal = this.f['newBookingTotal'].value

      this.bookingPrice = this.f['bookingPrice'].value;
      this.bookingAddon = this.f['bookingAddon'].value;
      this.bookingVAT = this.f['bookingVAT'].value;
      this.bookingTotal = this.f['bookingTotal'].value;
    }
    else
    {
      this.bookingPrice = this.f['bookingPrice'].value;
      this.bookingAddon = this.f['bookingAddon'].value;
      this.bookingVAT = this.f['bookingVAT'].value;
      this.bookingTotal = this.f['bookingTotal'].value;
    }
    this.bookingReOccurDays = this.f['bookingReOccurDays'].value
    this.bookingReOccurInstance = this.f['bookingReOccurInstance'].value
    this.bookingTotalWithReoocur = this.f['bookingTotalWithReoocur'].value
    this.totalRemainingAmount = this.f['totalRemainingAmount'].value
    this.totalDiscount = this.f['totalDiscount'].value

    let formattedDate = (moment(new Date(this.f['bookingDate'].value))).format('YYYY-MM-DD')

    let startTimeDT = new Date(this.bookingStartTime);
    let endTimeDT = new Date(this.bookingStartTime);
    endTimeDT.setMinutes(endTimeDT.getMinutes() + Number(this.endTiming));

    let formattedStartTime = startTimeDT.toTimeString().toString().substr(0, 8);
    let formattedEndTime = endTimeDT.toTimeString().toString().substr(0, 8);

    if (endTimeDT < startTimeDT) {
      endTimeDT.setDate(endTimeDT.getDate() + 1);
      }

    //const duration = (endTimeDT.getTime() - startTimeDT.getTime())/60000;
    const duration = Number(this.endTiming);
    console.log("duration__" + duration)
    console.log("formattedDate" + formattedDate);

    var mobileCheck = /^\d+$/.test(this.bookingMobile);

    // if (duration > 120)
    // {
    //   this.toastr.error('Booking duration cannot exceed 120 minutes', "Error");
    //   return;
    // }
    if (duration == 0)
    {
      this.toastr.error('Booking start/end time cannot be on same time', "Error");
      this.isLoading = false;
      return;
    }
    else if (this.bookingMobile.length < 8)
    {
      this.toastr.error('Mobile Number is below valid length', "Error");
      this.isLoading = false;
      return;
    }
    // else if (this.bookingMobile.length > 8)
    // {
    //   this.toastr.error('Mobile Number exceeds valid length', "Error");
    //   return;
    // }
    else if (!mobileCheck)
    {
      this.toastr.error('Mobile Number is invalid', "Error");
      this.isLoading = false;
      return;
    }

    var startDate = formattedDate + ' ' + formattedStartTime;
    var endTime = formattedDate + ' ' + formattedEndTime;


    var dbFunction = '';
    if (this.isUpdate && !this.isReoccur)
    {
      dbFunction = 'updateBookingCalendar';
      fd.append('bookingId',this.bookingId);
      //fd.append('facilityId',this.facilityId);
    }
    else if (this.isUpdate && this.isReoccur)
    {
      dbFunction = 'updateBookingCalendar';
      fd.append('bookingId',this.bookingId);
      fd.append('bookingReOccurInstance',this.bookingReOccurInstance);
      fd.append('bookingTotalWithReoocur',this.bookingTotalWithReoocur);
      fd.append('bookingReoccurStartTime',formattedStartTime);
      fd.append('bookingReoccurEndTime',formattedEndTime);
    }
    else if (!this.isUpdate && this.isReoccur)
    {
      dbFunction = 'addBookingCalendar';
      //fd.append('userId',this.userId);
      //fd.append('facilityId',this.facilityId);
      fd.append('channel','backoffice');
      fd.append('bookingReOccurInstance',this.bookingReOccurInstance);
      fd.append('bookingTotalWithReoocur',this.bookingTotalWithReoocur);
      fd.append('bookingReoccurStartTime',formattedStartTime);
      fd.append('bookingReoccurEndTime',formattedEndTime);
    }
    else if (!this.isUpdate)
    {
      dbFunction = 'addBookingCalendar';
      //fd.append('userId',this.userId);
      fd.append('facilityId',this.facilityId);
      fd.append('channel','backoffice');
    }

    if (this.bookingNotes == null)
    {
      this.bookingNotes = null;
    }
    fd.append('staffId',this.storageSrv.getUser());
    fd.append('facilityId',this.facilityId);
    fd.append('courtId',this.court);
    fd.append('bookingCategoryId',this.bookingCategoryId);
    fd.append('coachId',this.coachId);
    fd.append('paymentMethodCode',this.paymentMethod);
    fd.append('bookingName',this.bookingName);
    fd.append('bookingMobile',this.bookingMobile);
    fd.append('bookingCountryCode',this.bookingCountryCode);
    fd.append('notes',this.bookingNotes==null ? '' : this.bookingNotes);
    fd.append('bookingDate',formattedDate);
    fd.append('bookingStartTime',startDate);
    fd.append('bookingEndTime',endTime);
    fd.append('bookingDuration',duration.toString());
    fd.append('bookingPrice', this.bookingPrice);
    fd.append('bookingAddon', this.bookingAddon);
    fd.append('bookingVAT',this.bookingVAT);
    fd.append('bookingTotal',this.bookingTotal);
    fd.append('isReoccur',String(this.isReoccur));
    fd.append('ccy',this.ccy);
    fd.append('taxPercentage', String(this.taxPercentage*100));
    fd.append('bookingAddonArray',bookingAddons);
    fd.append('totalRemainingAmount',this.totalRemainingAmount.toString());
    fd.append('totalDiscount',this.totalDiscount.toString());

    let headers = new Headers();
    headers.append('Content-Type','application/json');

    this.httpService.post(dbFunction, fd, '')
    .then(
      data =>
      {
        if (this.isUpdate)
        {
          console.log(data);this.showSuccess('Booking updated');
          this.isLoading = false;
        }
        else
        {
          console.log(data);this.showSuccess('Booking added');
          this.isLoading = false;
        }
      },
      error =>
      {
        if (this.isUpdate)
        {
          this.isError = true;
          this.toastr.error(error.desc, "Error");
          console.log(error);
          this.isLoading = false;
        }
        else
        {
          this.isError = true;
          this.toastr.error(error.desc, "Error");
          console.log(error);
          this.isLoading = false;
        }
      },
    ).catch();
  }
  public cancelBooking(content: object)
  {
    var dbFunction = 'cancelBookingCalendar';

    var fd = new FormData();

    this.court = this.f['court'].value

    fd.append('bookingId',this.bookingId);
    fd.append('ownerId',this.ownerId);
    fd.append('facilityId',this.facilityId);
    fd.append('courtId',this.court);

    let headers = new Headers();
    headers.append('Content-Type','application/json');

    this.httpService.post(dbFunction, fd, '')
    .then(
      data =>
      {
        console.log(data);this.showSuccess('Booking cancelled');

      },
      error =>
      {
        if (this.isUpdate)
        {
          this.isError = true;
          this.toastComp.doShow('Error', 'An error has occured in db, please check missing and try again');
          console.log(error);
        }
        else
        {
          this.isError = true;
          this.toastComp.doShow('Error', 'An error has occured in db, please check missing and try again');
          console.log(error);
        }
      },
    ).catch();
  }
  //Function 1
  public findInvalidControls()
  {
    const invalid = [];
    const controls = this.simpleForm.controls;
    for (const name in controls) {
        if (controls[name].invalid) {
            invalid.push(name);
        }
    }
    return invalid;
  }
  //Function 2
  get f()
  {
    return this.simpleForm.controls;
  }
  //Function 3
  async showSuccess(msg) {
    await this.toastr.success(msg, 'Success');
    this.delay(1000).then(any=>{
      this.addBookingModal.hide();
      this.openEventModal.hide();
      this.simpleForm.patchValue({bookingName: ''});
      this.simpleForm.patchValue({totalDiscount: 0});
      this.closeModal();
      this.ngOnInit();
      //window.location.reload();
    });
  }
  //Function 4
   delay(ms: number) {
    return new Promise( resolve => setTimeout(resolve, ms) );
    }
  public updateCalendar()
  {
  }
  public closeModal()
  {
    this.simpleForm.patchValue({bookingName: null});
    this.simpleForm.patchValue({bookingMobile: null});
    this.simpleForm.patchValue({bookingCountryCode: null});
    this.simpleForm.patchValue({notes: null});
    this.memberId = null;
    this.membershipName = null;
    this.membershipDescription = null;
    // this.simpleForm.patchValue({newBookingPrice: null});
    // this.simpleForm.patchValue({newBookingAddon: null});
    // this.simpleForm.patchValue({newBookingVAT: null});
    // this.simpleForm.patchValue({newBookingTotal: null});
    this.bookingAddonsArray = [];
    if (this.isUpdate)
    {
      this.openEventModal.hide();
    }
    else
    {
      this.addBookingModal.hide();
    }
  }
  public openFullDetails()
  {
    if (this.isUpdate)
    {
      this.openEventModal.hide();
    }
    else
    {
      this.addBookingModal.hide();
    }
  }
  public roundTo = function(num: number, places: number) {
    const factor = 10 ** places;
    return Math.round(num * factor) / factor;
  };
  public updateReoccur()
  {
    this.updateReoccurDay();
    var status = this.f['bookingReOccur'].value;
    if (status == true)
    {
      this.bookingReOccur = true;
      //this.f['bookingReOccurDays'].enable();
      this.f['bookingReOccurInstance'].enable();
    }
    else
    {
      this.bookingReOccur = false;
      //this.f['bookingReOccur'].enable();
      this.f['bookingReOccurDays'].disable();
      this.f['bookingReOccurInstance'].disable();
      this.simpleForm.patchValue({bookingReOccurDays: null});
    }

    //console.log('selectedReoccurDay' + this.selectedReoccurDay);
    //this.bookingReOccur = true;
  }
  public updateReoccurDay()
  {
    var selectedDay = moment(new Date(this.f['bookingDate'].value)).format("dddd");
    this.selectedReoccurDay = selectedDay;
  }
  public updateReoccurTotal()
  {

  }
  public addAddon()
  {
    if (this.f['bookingAddonInstances'].value != '' && this.f['addon'].value != null)
    {
      var noInstances = parseInt(this.f['bookingAddonInstances'].value);
      var selectedAddon = this.f['addon'].value.split("|");
      console.log('selectedAddon' + JSON.stringify(selectedAddon));

      var price = parseFloat(selectedAddon[2]);
      if (noInstances > 0)
      {
      }
      else
      {
        return;
      }
      var total = noInstances * price;
      this.simpleForm.patchValue({bookingAddon: this.f['bookingAddon'].value + total});

      var isExisting = false;
      this.bookingAddonsArray.forEach(element => {
        if (element.id == selectedAddon[0])
        {
          isExisting = true;
          var index = this.bookingAddonsArray.splice(this.bookingAddonsArray.indexOf(element), 1);
          this.bookingAddonsArray.push({
            id: selectedAddon[0],
            name: selectedAddon[1],
            count: noInstances + element.count,
            price: price
          });
        }
      });

      if (!isExisting)
      {
        this.bookingAddonsArray.push({
          id: selectedAddon[0],
          name: selectedAddon[1],
          count: noInstances,
          price: price
        });
      }
    }
    this.updatePriceForAdd();
    this.isAddonBtn = false;
    this.simpleForm.patchValue({addon: null});
    this.simpleForm.patchValue({bookingAddonInstances: null, disabled:true});
    this.f['bookingAddonInstances'].disable();
  }
  public updateAddon()
  {
    this.isAddonBtn = true;
    this.f['bookingAddonInstances'].enable();
  }
  public removeAddon(addonId: number)
  {
    this.bookingAddonsArray = this.bookingAddonsArray.filter(({ id }) => id !== addonId);
    this.updatePriceForAdd();
  }
  public addAddonForEdit()
  {
    if (this.f['bookingAddonInstances'].value != '' && this.f['addon'].value != null)
    {
      var noInstances = parseInt(this.f['bookingAddonInstances'].value);
      var selectedAddon = this.f['addon'].value.split("|");
      console.log('selectedAddon' + JSON.stringify(selectedAddon));
      console.log('noInstances' + noInstances);

      var price = parseFloat(selectedAddon[2]);
      if (noInstances <= 0)
      {
        return;
      }

      var total = noInstances * price;
      this.simpleForm.patchValue({bookingAddon: this.f['bookingAddon'].value + total});

      var isExisting = false;
      console.log('step0');

      for (let index = 0; index < this.bookingAddonsArray.length; index++) {
        const element = this.bookingAddonsArray[index];
        console.log('step1');
        if (element.id == selectedAddon[0])
        {
          console.log('step2');
          isExisting = true;
          this.bookingAddonsArray.splice(this.bookingAddonsArray.indexOf(element), 1);
          this.bookingAddonsArray.push({
            id: selectedAddon[0],
            name: selectedAddon[1],
            count: parseInt(element.count.toString()) + parseInt(noInstances.toString()),
            price: price
          });
          break;
        }
      }

      if (!isExisting)
      {
        console.log('step3');
        this.bookingAddonsArray.push({
          id: selectedAddon[0],
          name: selectedAddon[1],
          count: noInstances,
          price: price
        });
      }
    }
    this.updatePriceForEdit();
    this.isAddonBtn = false;
    this.simpleForm.patchValue({addon: null});
    this.simpleForm.patchValue({bookingAddonInstances: null, disabled:true});
    this.f['bookingAddonInstances'].disable();
  }
  public updateAddonForEdit()
  {
    this.isAddonBtn = true;
    this.f['bookingAddonInstances'].enable();
  }
  public removeAddonForEdit(addonId: number)
  {
    this.bookingAddonsArray = this.bookingAddonsArray.filter(({ id }) => id !== addonId);
    this.updatePriceForEdit();
  }
  public updatePriceForAdd()
  {
    var subTotalPrice;
    var addon;
    var vat;
    var total;
    var totalReoccur;
    var addonTotalPrice = 0.0;
    this.isReoccur = this.f['bookingReOccur'].value;
    let selectedCourtId = this.f['court'].value != null ? this.f['court'].value : 0;

    let startTimeDT = new Date(this.f['bookingStartTime'].value);
    let endTimeDT = new Date(this.f['bookingStartTime'].value)
    let endTiming = this.f['endTiming'].value
    endTimeDT.setMinutes(endTimeDT.getMinutes() + Number(endTiming));

    if (endTimeDT < startTimeDT) {
      endTimeDT.setDate(endTimeDT.getDate() + 1);
    }

    const duration = (endTimeDT.getTime() - startTimeDT.getTime())/60000;

    var reoccurInstances;
    if (this.isReoccur)
    {
      if (this.f['bookingReOccurInstance'].value == '' || this.f['bookingReOccurInstance'].value == null || this.f['bookingReOccurInstance'].value == '0')
      {
        reoccurInstances = 1;
      }
      else
      {
        reoccurInstances = parseInt(this.f['bookingReOccurInstance'].value);
      }
    }

    var existingSubTotalPrice = parseFloat(this.f['bookingPrice'].value);
    var existingAddonPrice = parseFloat(this.f['bookingAddon'].value);
    var existingVATPrice = parseFloat(this.f['bookingVAT'].value);
    var existingTotalPrice = parseFloat(this.f['bookingTotal'].value);

    var newSubTotalPrice = 0.0;
    var newAddonPrice = 0.0;
    var newVATPrice = 0.0;
    var newTotalPrice = 0.0;

    var courtId = null;

    if (this.f['court'].value == '' || this.f['court'].value == null || this.f['court'].value == '0')
    {
      selectedCourtId = null;
    }
    else
    {
      this.updateCourtOfferPrices(selectedCourtId, startTimeDT, endTimeDT)
    }

    if (duration == 30)
    {
      this.courtPrice = this.courtPrice30min;
    }
    else if (duration == 60)
    {
      this.courtPrice = this.courtPrice60min;
    }
    else if (duration == 90)
    {
      this.courtPrice = this.courtPrice90min;
    }
    else if (duration == 120)
    {
      this.courtPrice = this.courtPrice120min;
    }
    else if (duration > 120)
    {
      var totalExtraTime = duration - 120;
      var totalExtraSlots = totalExtraTime / 30;
      var totalExtraPrice = totalExtraSlots * this.courtPrice30min;
      this.courtPrice = this.courtPrice120min + totalExtraPrice;
    }
    else
    {
      this.courtPrice = this.courtPrice120min;
    }

    subTotalPrice = this.courtPrice;

    //1
    newSubTotalPrice = this.courtPrice;

    for (let addonItem of this.bookingAddonsArray)
    {
      var addonItemPrice = addonItem.price * addonItem.count;
      addonTotalPrice = addonTotalPrice + addonItemPrice;
    }

    //2
    newAddonPrice = addonTotalPrice;

    //3
    var totalPriceWithAddon = (newSubTotalPrice + newAddonPrice);
    vat = totalPriceWithAddon * this.taxPercentage;
    newVATPrice = vat;

    //4
    newTotalPrice = newSubTotalPrice + newAddonPrice + (this.taxOnus == '1' ? 0 : vat);


    if (this.isReoccur)
    {
      //var subTotalPriceR = subTotalPrice * reoccurInstances;
      //var vatR = vat * reoccurInstances;
      totalReoccur = total * reoccurInstances;
    }

    console.log('duration ' + duration);
    console.log('courtPrice ' + this.courtPrice);
    console.log('subTotalPrice ' + newSubTotalPrice);
    console.log('vat' + newVATPrice);
    console.log('addon ' + newAddonPrice);
    console.log('total ' + newTotalPrice);
    console.log('totalReoccur ' + totalReoccur);

    this.simpleForm.patchValue({bookingPrice: this.roundTo(newSubTotalPrice, 3), disabled:false});
    this.simpleForm.patchValue({bookingAddon: this.roundTo(newAddonPrice, 3)});
    this.simpleForm.patchValue({bookingVAT: this.roundTo(newVATPrice, 3), disabled:true});
    this.simpleForm.patchValue({bookingTotal: this.roundTo(newTotalPrice, 3)});
    this.simpleForm.patchValue({bookingTotalWithReoocur: this.roundTo(totalReoccur, 3)});

    // var existingTotalPrice = parseFloat(this.f['bookingTotal'].value);
    // var newTotalPrice = parseFloat(this.f['newBookingTotal'].value);
    var newTotalPrice = newTotalPrice;
    var diff = (newTotalPrice - existingTotalPrice);
    this.simpleForm.patchValue({totalRemainingAmount: this.roundTo(diff, 3)});
  }
  public updatePriceForAddPrice()
  {
    var subTotalPrice;
    var addon;
    var vat;
    var total;
    var totalReoccur;
    var addonTotalPrice = 0.0;
    //var startDate = new Date(this.f['bookingStartTime'].value);
    //var endDate = new Date(this.f['bookingEndTime'].value);
    this.isReoccur = this.f['bookingReOccur'].value;
    let selectedCourtId = this.f['court'].value != null ? this.f['court'].value : 0;

    let startTimeDT = new Date(this.f['bookingStartTime'].value);
    let endTimeDT = new Date(this.f['bookingStartTime'].value)
    let endTiming = this.f['endTiming'].value
    endTimeDT.setMinutes(endTimeDT.getMinutes() + Number(endTiming));

    if (endTimeDT < startTimeDT) {
      endTimeDT.setDate(endTimeDT.getDate() + 1);
      }

    const duration = (endTimeDT.getTime() - startTimeDT.getTime())/60000;

    var reoccurInstances;
    if (this.isReoccur)
    {
      if (this.f['bookingReOccurInstance'].value == '' || this.f['bookingReOccurInstance'].value == null || this.f['bookingReOccurInstance'].value == '0')
      {
        reoccurInstances = 1;
      }
      else
      {
        reoccurInstances = parseInt(this.f['bookingReOccurInstance'].value);
      }
    }

    if (this.f['court'].value == '' || this.f['court'].value == null || this.f['court'].value == '0')
    {
      selectedCourtId = null;
    }
    else
    {
      this.updateCourtOfferPrices(selectedCourtId, startTimeDT, endTimeDT)
    }


    var existingSubTotalPrice = parseFloat(this.f['bookingPrice'].value);
    var existingAddonPrice = parseFloat(this.f['bookingAddon'].value);
    var existingVATPrice = parseFloat(this.f['bookingVAT'].value);
    var existingTotalPrice = parseFloat(this.f['bookingTotal'].value);

    var newSubTotalPrice = parseFloat(this.f['bookingPrice'].value);
    var newAddonPrice = 0.0;
    var newVATPrice = 0.0;
    var newTotalPrice = 0.0;

    // if (this.f['bookingAddon'].value == '')
    // {
    //   addon = 0.0;
    // }
    // else if (parseFloat(this.f['bookingAddon'].value) > 0)
    // {
    //   addon = parseFloat(this.f['bookingAddon'].value);
    // }
    // else
    // {
    //   addon = addonTotalPrice;
    // }

    if (duration == 30)
    {
      this.courtPrice = this.courtPrice30min;
    }
    else if (duration == 60)
    {
      this.courtPrice = this.courtPrice60min;
    }
    else if (duration == 90)
    {
      this.courtPrice = this.courtPrice90min;
    }
    else if (duration == 120)
    {
      this.courtPrice = this.courtPrice120min;
    }
    else if (duration > 120)
    {
      var totalExtraTime = duration - 120;
      var totalExtraSlots = totalExtraTime / 30;
      var totalExtraPrice = totalExtraSlots * this.courtPrice30min;
      this.courtPrice = this.courtPrice120min + totalExtraPrice;
    }
    else
    {
      this.courtPrice = this.courtPrice120min;
    }

    //subTotalPrice = this.courtPrice;

    //1
    //newSubTotalPrice = this.courtPrice;

    for (let addonItem of this.bookingAddonsArray)
    {
      var addonItemPrice = addonItem.price * addonItem.count;
      addonTotalPrice = addonTotalPrice + addonItemPrice;
    }

    //2
    newAddonPrice = addonTotalPrice;

    //3
    var totalPriceWithAddon = (newSubTotalPrice + newAddonPrice);
    vat = totalPriceWithAddon * this.taxPercentage;
    newVATPrice = vat;

    //4
    newTotalPrice = newSubTotalPrice + newAddonPrice + this.taxOnus == '1' ? 0 : vat;

    if (this.isReoccur)
    {
      //var subTotalPriceR = subTotalPrice * reoccurInstances;
      //var vatR = vat * reoccurInstances;
      totalReoccur = total * reoccurInstances;
    }

    console.log('duration ' + duration);
    console.log('courtPrice ' + this.courtPrice);
    console.log('subTotalPrice ' + newSubTotalPrice);
    console.log('vat ' + newVATPrice);
    console.log('addon ' + newAddonPrice);
    console.log('total ' + newTotalPrice);
    console.log('totalReoccur ' + totalReoccur);

    //this.simpleForm.patchValue({bookingPrice: this.roundTo(newSubTotalPrice, 3), disabled:true});
    this.simpleForm.patchValue({bookingAddon: this.roundTo(newAddonPrice, 3)});
    this.simpleForm.patchValue({bookingVAT: this.roundTo(newVATPrice, 3), disabled:true});
    this.simpleForm.patchValue({bookingTotal: this.roundTo(newTotalPrice, 3)});
    this.simpleForm.patchValue({bookingTotalWithReoocur: this.roundTo(totalReoccur, 3)});

    // var existingTotalPrice = parseFloat(this.f['bookingTotal'].value);
    // var newTotalPrice = parseFloat(this.f['newBookingTotal'].value);
    var newTotalPrice = newTotalPrice;
    var diff = (newTotalPrice - existingTotalPrice);
    this.simpleForm.patchValue({totalRemainingAmount: this.roundTo(diff, 3)});
  }
  public updatePriceForEditPrice()
  {
    var subTotalPrice;
    var addon;
    var vat;
    var total;
    var totalReoccur;
    var addonTotalPrice = 0.0;
    //var startDate = new Date(this.f['bookingStartTime'].value);
    //var endDate = new Date(this.f['bookingEndTime'].value);
    this.isReoccur = this.f['bookingReOccur'].value;


    let startTimeDT = new Date(this.f['bookingStartTime'].value);
    let endTimeDT = new Date(this.f['bookingStartTime'].value)
    let endTiming = this.f['endTiming'].value
    endTimeDT.setMinutes(endTimeDT.getMinutes() + Number(endTiming));

    if (endTimeDT < startTimeDT) {
      endTimeDT.setDate(endTimeDT.getDate() + 1);
      }

    const duration = (endTimeDT.getTime() - startTimeDT.getTime())/60000;
    console.log("duration__" + duration)

    // if (duration > 120)
    // {
    //   var minutesToAdd=30;
    //   var futureDate = new Date(startDate.getTime() + minutesToAdd*60000);
    //   this.simpleForm.patchValue({bookingStartTime: futureDate});
    // }

    //FOR TESTING TO BE REMOVED
    //this.isReoccur = false;

    var reoccurInstances;
    if (this.isReoccur)
    {
      if (this.f['bookingReOccurInstance'].value == '' || this.f['bookingReOccurInstance'].value == null || this.f['bookingReOccurInstance'].value == '0')
      {
        reoccurInstances = 1;
      }
      else
      {
        reoccurInstances = parseInt(this.f['bookingReOccurInstance'].value);
      }
    }

    var existingSubTotalPrice = parseFloat(this.f['bookingPrice'].value === '' ? '0' : this.f['bookingPrice'].value);
    var existingAddonPrice = parseFloat(this.f['bookingAddon'].value);
    var existingVATPrice = parseFloat(this.f['bookingVAT'].value);
    var existingTotalPrice = parseFloat(this.f['bookingTotal'].value);
    var paidAmount = parseFloat(this.f['bookingPayAmount'].value);

    var newSubTotalPrice = isNaN(existingSubTotalPrice) ? 0 : existingSubTotalPrice;
    var newAddonPrice = 0.0;
    var newVATPrice = 0.0;
    var newTotalPrice = 0.0;

    if (duration == 30)
    {
      this.courtPrice = this.courtPrice30min;
    }
    else if (duration == 60)
    {
      this.courtPrice = this.courtPrice60min;
    }
    else if (duration == 90)
    {
      this.courtPrice = this.courtPrice90min;
    }
    else if (duration == 120)
    {
      this.courtPrice = this.courtPrice120min;
    }
    else if (duration > 120)
    {
      var totalExtraTime = duration - 120;
      var totalExtraSlots = totalExtraTime / 30;
      var totalExtraPrice = totalExtraSlots * this.courtPrice30min;
      this.courtPrice = this.courtPrice120min + totalExtraPrice;
    }
    else
    {
      this.courtPrice = this.courtPrice120min;
    }

    //subTotalPrice = this.courtPrice;

    //1
    //newSubTotalPrice = this.courtPrice;

    if (this.bookingAddonsArray.length > 0)
    {
      if (this.existingBookingAddonArray != null)
      {
        if (this.bookingAddonsArray.length >= this.existingBookingAddonArray.length)
        {
          for (let addonItem of this.bookingAddonsArray)
          {
            var addonItemPrice = addonItem.price * addonItem.count;
            addonTotalPrice = addonTotalPrice + addonItemPrice;
          }
          newAddonPrice = addonTotalPrice;
        }
        else if (this.bookingAddonsArray.length < this.existingBookingAddonArray.length)
        {
          for (let addonItem of this.bookingAddonsArray)
          {
            var addonItemPrice = addonItem.price * addonItem.count;
            addonTotalPrice = addonTotalPrice - addonItemPrice;
          }
          newAddonPrice = addonTotalPrice * -1;
        }
        else
        {
          newAddonPrice = existingAddonPrice;
        }
      }
      else
      {
        newAddonPrice = existingAddonPrice;
      }
    }
    else if (this.bookingAddonsArray.length == 0)
    {
      newAddonPrice = 0;
    }
    else
    {
      newAddonPrice = existingAddonPrice;
    }


    console.log('addonTotalPrice ' + addonTotalPrice);
    console.log('existingAddonPrice ' + existingAddonPrice);

    //2

    //3
    var totalPriceWithAddon = (newSubTotalPrice + newAddonPrice);
    vat = totalPriceWithAddon * this.taxPercentage;
    newVATPrice = vat;

    //4
    newTotalPrice = newSubTotalPrice + newAddonPrice + newVATPrice;

    if (this.isReoccur)
    {
      totalReoccur = total * reoccurInstances;
    }

    console.log('duration ' + duration);
    console.log('courtPrice ' + this.courtPrice);
    console.log('this.taxPercentage ' + this.taxPercentage);
    console.log('newSubTotalPrice ' + newSubTotalPrice);
    console.log('newVATPrice ' + newVATPrice);
    console.log('newAddonPrice ' + newAddonPrice);
    console.log('newTotalPrice ' + newTotalPrice);
    console.log('totalReoccur ' + totalReoccur);


    this.simpleForm.patchValue({bookingAddon: this.roundTo(newAddonPrice, 3)});
    this.simpleForm.patchValue({bookingVAT: this.roundTo(newVATPrice, 3), disabled:true});
    this.simpleForm.patchValue({bookingTotal: this.roundTo(newTotalPrice, 3)});
    this.simpleForm.patchValue({bookingTotalWithReoocur: this.roundTo(totalReoccur, 3)});

    var diff = (newTotalPrice - paidAmount);
    this.simpleForm.patchValue({totalRemainingAmount: this.roundTo(diff, 3)});

  }
  public updatePriceForEdit()
  {
    var subTotalPrice;
    var addon;
    var vat;
    var total;
    var totalReoccur;
    var addonTotalPrice = 0.0;
    //var startDate = new Date(this.f['bookingStartTime'].value);
    //var endDate = new Date(this.f['bookingEndTime'].value);
    this.isReoccur = this.f['bookingReOccur'].value;
    this.totalDiscount = this.f['totalDiscount'].value;


    let startTimeDT = new Date(this.f['bookingStartTime'].value);
    let endTimeDT = new Date(this.f['bookingStartTime'].value);
    let endTiming = this.f['endTiming'].value
    endTimeDT.setMinutes(endTimeDT.getMinutes() + Number(endTiming));

    if (endTimeDT < startTimeDT) {
      endTimeDT.setDate(endTimeDT.getDate() + 1);
      }

    const duration = (endTimeDT.getTime() - startTimeDT.getTime())/60000;

    //FOR TESTING TO BE REMOVED
    //this.isReoccur = false;

    var reoccurInstances;
    if (this.isReoccur)
    {
      if (this.f['bookingReOccurInstance'].value == '' || this.f['bookingReOccurInstance'].value == null || this.f['bookingReOccurInstance'].value == '0')
      {
        reoccurInstances = 1;
      }
      else
      {
        reoccurInstances = parseInt(this.f['bookingReOccurInstance'].value);
      }
    }


    var existingSubTotalPrice = parseFloat(this.f['bookingPrice'].value === '' ? '0' : this.f['bookingPrice'].value);
    var existingAddonPrice = parseFloat(this.f['bookingAddon'].value);
    var existingVATPrice = parseFloat(this.f['bookingVAT'].value);
    const existingTotalPrice = parseFloat(this.f['bookingTotal'].value);
    const paidAmount = parseFloat(this.f['bookingPayAmount'].value);

    var newSubTotalPrice = parseFloat(this.f['bookingPrice'].value === '' ? '0' : this.f['bookingPrice'].value);
    var newAddonPrice = 0.0;
    var newVATPrice = 0.0;
    var newTotalPrice = 0.0;

    var courtId = null;

    if (this.f['court'].value == '' || this.f['court'].value == null || this.f['court'].value == '0')
    {
      courtId = null;
    }
    else
    {
      console.log("eeeeee");
      courtId = parseInt(this.f['court'].value);
      this.updateCourtOfferPrices(courtId, startTimeDT, endTimeDT)
    }

    if (duration == 30)
    {
      this.courtPrice = this.courtPrice30min;
    }
    else if (duration == 60)
    {
      this.courtPrice = this.courtPrice60min;
    }
    else if (duration == 90)
    {
      this.courtPrice = this.courtPrice90min;
    }
    else if (duration == 120)
    {
      this.courtPrice = this.courtPrice120min;
    }
    else if (duration > 120)
    {
      var totalExtraTime = duration - 120;
      var totalExtraSlots = totalExtraTime / 30;
      var totalExtraPrice = totalExtraSlots * this.courtPrice30min;
      this.courtPrice = this.courtPrice120min + totalExtraPrice;
    }
    else
    {
      this.courtPrice = this.courtPrice120min;
    }

    //subTotalPrice = this.courtPrice;

    //1
    newSubTotalPrice = this.courtPrice;

    if (this.bookingAddonsArray.length > 0)
    {
      if (this.existingBookingAddonArray != null)
      {
        if (this.bookingAddonsArray.length >= this.existingBookingAddonArray.length)
        {
          for (let addonItem of this.bookingAddonsArray)
          {
            var addonItemPrice = addonItem.price * addonItem.count;
            addonTotalPrice = addonTotalPrice + addonItemPrice;
          }
          newAddonPrice = addonTotalPrice;
        }
        else if (this.bookingAddonsArray.length < this.existingBookingAddonArray.length)
        {
          for (let addonItem of this.bookingAddonsArray)
          {
            var addonItemPrice = addonItem.price * addonItem.count;
            addonTotalPrice = addonTotalPrice - addonItemPrice;
          }
          newAddonPrice = addonTotalPrice * -1;
        }
        else
        {
          newAddonPrice = existingAddonPrice;
        }
      }
      else
      {
        newAddonPrice = existingAddonPrice;
      }
    }
    else if (this.bookingAddonsArray.length == 0)
    {
      newAddonPrice = 0;
    }
    else
    {
      newAddonPrice = existingAddonPrice;
    }
    //2

    //3
    var totalPriceWithAddon = (newSubTotalPrice + newAddonPrice);
    vat = totalPriceWithAddon * this.taxPercentage;
    newVATPrice = vat;

    if (this.totalDiscount > 0)
    {
      newSubTotalPrice = newSubTotalPrice - (newSubTotalPrice * (this.totalDiscount/100));
    }
    else
    {
      this.totalDiscount = 0;
    }

    newTotalPrice = newSubTotalPrice + newAddonPrice + newVATPrice;

    //4

    if (this.isReoccur)
    {
      //var subTotalPriceR = subTotalPrice * reoccurInstances;
      //var vatR = vat * reoccurInstances;
      totalReoccur = total * reoccurInstances;
    }

    console.log('duration ' + duration);
    console.log('courtPrice ' + this.courtPrice);
    console.log('this.taxPercentage ' + this.taxPercentage);
    console.log('newSubTotalPrice ' + newSubTotalPrice);
    console.log('newVATPrice ' + newVATPrice);
    console.log('newAddonPrice ' + newAddonPrice);
    console.log('newTotalPrice ' + newTotalPrice);
    console.log('totalReoccur ' + totalReoccur);
    console.log('totalDiscount ' + this.totalDiscount);

    this.simpleForm.patchValue({bookingPrice: this.roundTo(newSubTotalPrice, 3), disabled:false});
    this.simpleForm.patchValue({bookingAddon: this.roundTo(newAddonPrice, 3)});
    this.simpleForm.patchValue({bookingVAT: this.roundTo(newVATPrice, 3), disabled:true});
    this.simpleForm.patchValue({bookingTotal: this.roundTo(newTotalPrice, 3)});
    this.simpleForm.patchValue({bookingTotalWithReoocur: this.roundTo(totalReoccur, 3)});

    var diff = (newTotalPrice - paidAmount);
    this.simpleForm.patchValue({totalRemainingAmount: this.roundTo(diff, 3)});
  }
  public goFullDetails(bookingId) {
    if (this.classId != null && this.classId != '') {
      this.router.navigate([`/class/details/${bookingId}`], {state: {bookingId: bookingId}, relativeTo: this.route});
    } else {
      // console.log('blah blah',moment(this.calendarCurrentDate).format('YYYY-MM-DD'));
      this.storageSrv.setLastSelectedDate(moment(this.calendarCurrentDate).format('YYYY-MM-DD'))
      this.router.navigate([`/booking/details/${bookingId}`], {state: {bookingId: bookingId}, relativeTo: this.route});

    }
  }
  updateCourtOfferPrices(selectedCourtId, startTimeDT, endTimeDT)
  {
    var isOffer = false;
    for (let offer of this.courts.offers)
    {
      isOffer = true;
      var offerStartDate = new Date(offer.startDT.replace(/-/g, "/"));
      var offerEndDate = new Date(offer.endDT.replace(/-/g, "/"));

      var courtIds = offer.courtIds?.split(',');
      var reoccurDays = offer.reoccurDays?.split(',');

      if (startTimeDT >= offerStartDate && startTimeDT <= offerEndDate && courtIds.indexOf(selectedCourtId.toString()) > -1)
      {

        // var bookingStartTime = moment(startTimeDT).format("HH:mm:ss");
        // var bookingEndTime = moment(endTimeDT).format("HH:mm:ss");
        // var offerStartTime = moment(new Date(offer["startTime"])).format("HH:mm:ss");
        // var offerEndTime = moment(new Date(offer["endTime"])).format("HH:mm:ss");

        var bookingStartDate = moment(startTimeDT).format("YYYY-MM-DD");
        var offerStartTime = moment(bookingStartDate + ' ' + offer["startTimeOnly"]).format("YYYY-MM-DD HH:mm:ss");

        var bookingStartTime = moment(startTimeDT).format("YYYY-MM-DD HH:mm:ss");
        var bookingEndTime = moment(endTimeDT);

        var bookingEndDate = moment(endTimeDT).format("YYYY-MM-DD");

        if (offer["endTimeOnly"] > offer["startTimeOnly"])
        {
          bookingEndDate = bookingStartDate;
        }

        var offerEndTime = moment(bookingEndDate + ' ' + offer["endTimeOnly"]).format("YYYY-MM-DD HH:mm:ss");

        // if (bookingEndTime.toString() == "00:00:00")
        // {
        //   bookingEndTime = '23:59:59';
        // }

        // console.log("offerStartTime" + offerStartTime);
        // console.log("offerEndTime" + offerEndTime);
        // console.log("bookingStartTime" + bookingStartTime);
        // console.log("bookingEndDate" + bookingEndDate);

        this.updateReoccurDay();

        if (bookingStartTime >= offerStartTime && bookingStartTime < offerEndTime && courtIds.indexOf(selectedCourtId.toString()) > -1 && reoccurDays.indexOf(this.selectedReoccurDay.toLowerCase()) > -1)
        {
          this.courtPrice30min = parseFloat(offer["30minPrice"]);
          this.courtPrice60min = parseFloat(offer["60minPrice"]);
          this.courtPrice90min = parseFloat(offer["90minPrice"]);
          this.courtPrice120min = parseFloat(offer["120minPrice"]);
          return;
        }
        else
        {
          for (let court of this.courts)
          {
            if (court.id == selectedCourtId)
            {
              this.courtPrice30min = parseFloat(court["30minPrice"]);
              this.courtPrice60min = parseFloat(court["60minPrice"]);
              this.courtPrice90min = parseFloat(court["90minPrice"]);
              this.courtPrice120min = parseFloat(court["120minPrice"]);
            }
          }
        }
      }
      else
      {
        for (let court of this.courts)
        {
          if (court.id == selectedCourtId)
          {
            this.courtPrice30min = parseFloat(court["30minPrice"]);
            this.courtPrice60min = parseFloat(court["60minPrice"]);
            this.courtPrice90min = parseFloat(court["90minPrice"]);
            this.courtPrice120min = parseFloat(court["120minPrice"]);
          }
        }
      }
    }

    for (let court of this.courts)
    {
      if (court.id == selectedCourtId)
      {
        this.courtPrice30min = parseFloat(court["30minPrice"]);
        this.courtPrice60min = parseFloat(court["60minPrice"]);
        this.courtPrice90min = parseFloat(court["90minPrice"]);
        this.courtPrice120min = parseFloat(court["120minPrice"]);
      }
    }

  }
  getCustomerInfo = () => {
    var mobile = this.f['bookingMobile'].value;
    var countryCode = this.f['bookingCountryCode'].value;
    if (mobile != '' && mobile != null && mobile != '0' && mobile.length >= 8 &&
      countryCode != '' && countryCode != null && countryCode != '0' && countryCode.length == 3)
    {
      return new Promise<any>(async (resolve, reject) => {
        this.localInterfaceSrv.getCustomerInfo(mobile, countryCode)
        .then(res => {
          if (res.content.customerName != "" && res.content.customerName != null)
          {
            this.f['bookingName'].setValue(res.content.customerName);
            this.memberId = res.content.membershipId;
            this.membershipName = res.content.membershipName;
            this.membershipDescription = res.content.membershipDescription;
          }
          resolve(res);
        })
        .catch(err => {
          reject(err);
          console.log(err)
          this.toastr.error(err.desc, "Error");
        })
        .finally(() => this.isLoading = false);
      });
    }
  }
  get simpleProps() {
    const content = this.sanitize(
      '<h3 class="popover-header">' + this.membershipName + '</h3> <div class="popover-body">' + this.membershipDescription + '</div>'
    );
    return { ...this.tippyPropsDefault, content, trigger: 'mouseenter focus' };
  }

  tippyPropsDefault = {
    allowHTML: true,
    appendTo: 'parent',
    theme: 'cpopover',
    trigger: 'click',
    placement: 'right'
  };

  sanitize(value) {
    return this.sanitizer.sanitize(SecurityContext.HTML, value);
  }
  loadBookingCategory = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      this.dbActiveData = Array();
      this.localInterfaceSrv.getBookingCategory(facilityId)
      .then(res => {
        this.responseData = Object.values(res);
        this.responseData[0].forEach(item => {
          if (item.status=='A')
          {
            const newObj = item;
            this.dbActiveData.push(newObj);
          }
        });
        this.bookingCategories = this.dbActiveData;
        this.bookingCategories.content = this.dbActiveData;
        //this.taxPercentage = this.courts.content.taxPercentage/100;
        resolve(res);
      })
      .catch(err => {
        reject(err);
        console.log(err)
        this.toastr.error(err.desc, "Error");
      })
      .finally();
    });
  }
  loadCoaches = () => {
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      this.dbActiveData = Array();
      this.localInterfaceSrv.getCoachesByFacility()
      .then(res => {
        this.responseData = Object.values(res);
        this.coaches = res;
        //this.taxPercentage = this.courts.content.taxPercentage/100;
        resolve(res);
      })
      .catch(err => {
        reject(err);
        console.log(err)
        this.toastr.error(err.desc, "Error");
      })
      .finally();
    });
  }
  // Auto refresh
  private autoRefreshInterval: any;
  toggleAutoRefresh(event: any) {
    if (event.checked) {
      this.autoRefreshInterval = setInterval(() => {
        this.getCurrentDateData();
      }, 30 * 1000); // 30 seconds
    } else {
      if (this.autoRefreshInterval) {
        clearInterval(this.autoRefreshInterval);
      }
    }
  }
}
